import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "../../styles/home/latest-news.css";
import { getAllHomeData } from '../../Services/AllAPIs';

const LatestNews = () => {

    const [loader, setLoader] = useState(true);
    const [latestNewsData, setLatestNewsData] = useState([]);
    const [error, setError] = useState(null);

    // Fetch latest news
    const getLatestNews = () => {
        getAllHomeData()
            .then((res) => {
                // console.log('Latest news data:', res.data.home.announcements);
                const announcements = res.data.home.announcements;
                setLatestNewsData(announcements);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setError("An error occurred while fetching the news.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getLatestNews();
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2 announcement-area">
                    <h5>Latest @CCSU</h5>
                </div>
                <div className="col-md-10 announcement-content">
                    <div className="scrolling-news">
                        <div className="news-items">
                            {loader && <p>Loading latest news...</p>}
                            {error && <p className="error">{error}</p>}

                            {/* Dynamically render the news items from the API */}
                            {latestNewsData.length > 0 ? (
                                latestNewsData.map((announcement, index) => (
                                    <Link
                                        key={announcement.id}
                                        to={announcement.url || '#'}
                                        target="_blank"
                                        className="blu"
                                    >
                                        {announcement.title} &nbsp; &nbsp; | &nbsp; &nbsp;
                                    </Link>
                                ))
                            ) : (
                                <p>No latest news available.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LatestNews;
